module.exports = __webpack_public_path__ + "static/media/icon-download-off.d123efd6.svg";